window.addEventListener('DOMContentLoaded', () => {
    if (typeof gh_content_key === 'string' && document.querySelector('body').classList.contains('custom-collections-page')) {
        setFilteredList();
        loadFilteredList({slug: 'all'});
    }
});

const collectionPostCardTemplate = (post) => {
    const url = post.url;
    const title = post.title;
    const thumb = post.feature_image.replace('/content/images/', '/content/images/size/w320/format/webp/');

    return `<article class="gh-card">
        <a class="gh-card-link" href="${url}">
            <figure class="gh-card-image">
                <img src="${thumb}" alt="${title}" loading="lazy">
            </figure>
            <div class="gh-card-wrapper">
                <h3 class="gh-card-title is-title">${title}</h3>
            </div>
        </a>
    </article>`
};

function setFilteredList() {
    let tagLinks = document.querySelectorAll('.collections-tags-list a[data-tags-slug]');
    let tagButtons = document.querySelectorAll('.collections-more .gh-button');

    tagLinks.forEach(function(link) {
        link.addEventListener('click', async function (e) {
            e.preventDefault();
            let slug = this.getAttribute('data-tags-slug');

            document.querySelectorAll('.collections-tags-list a.active').forEach((link) => link.classList.remove('active'));

            link.classList.add('active');

            loadFilteredList({slug});
        });
    });
    
    tagButtons.forEach(function(button) {
        button.addEventListener('click', async function (e) {
            e.preventDefault();
            let slug = this.getAttribute('data-collection-button-slug');

            loadFilteredList({slug});
        });
    });
}

async function loadFilteredList({slug}) {
    document.querySelectorAll(`[data-collection]:not([data-collection="${slug}"])`).forEach((feed) => {
        feed.classList.add('collections-feed-hidden');
    });
    document.querySelector(`[data-collection="${slug}"]`).classList.remove('collections-feed-hidden');

    // If item is empty, get some data
    if (document.querySelector(`[data-collection="${slug}"] .gh-feed`).attributes.getNamedItem('data-is-empty')) {
        var filterString = document.querySelector(`[data-collection="${slug}"]`).attributes.getNamedItem('data-filter').value;
        
        return getTabContent({
            filterString,
            elementSelector: `[data-collection="${slug}"]`
        });
    }
}

function getTabContent(options) {
    var hasNextPage = document.querySelector(options.elementSelector).getAttribute('data-meta-pagination-next') ?? false;

    return contentAPI.posts.browse({
        limit: 12,
        fields: 'title,url,feature_image',
        filter: 'tags:[' + options.filterString + ']',
        page: hasNextPage || 1
    }).then(function(posts) {
        posts.forEach(function(post) {
            document.querySelector(`${options.elementSelector} .gh-feed`).innerHTML += collectionPostCardTemplate(post);
        });

        var endingPostCount = document.querySelectorAll(`${options.elementSelector} .gh-card`).length;

        document.querySelector(options.elementSelector).setAttribute('data-page-loaded', endingPostCount);
        document.querySelector(options.elementSelector).setAttribute('data-meta-pagination-next', posts.meta.pagination.next);
        
        if (endingPostCount === posts.meta.pagination.total) {
            document.querySelector(options.elementSelector).setAttribute('data-loaded-all', true);
            document.querySelector(`${options.elementSelector} .gh-button`).classList.add('collections-button-hidden');
        } else {
            document.querySelector(`${options.elementSelector} .gh-button`).classList.remove('collections-button-hidden');
        }

        return {posts, meta: posts.meta};
    }).catch(function(err) {
        console.log(err);
    });
}
